import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from 'assets/locales/en.json';
import dk from 'assets/locales/dk.json';
import no from 'assets/locales/no.json';
import se from 'assets/locales/se.json';

const languages = ['se', 'dk', 'no'];

const resources = {
  en: {
    translation: en,
  },
  se: {
    translation: se,
  },
  dk: {
    translation: dk,
  },
  no: {
    translation: no,
  },
};

const path = window.location.origin.slice(-2);

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: languages.includes(path) ? path : 'en',
});

export default i18n;
